module.exports = __webpack_public_path__ + "static/image4-1edf3e148fe7198a965c45f26c6a906c.png";